import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = () => {
  return [
    { title: "法務法人フィサン | 韓国の日本語対応弁護士 - 国際離婚・刑事・金融・不動産専門" },
    { name: "description", content: "韓国ソウルの日本語対応法律事務所。国際離婚、刑事事件、金融・企業法務、不動産PF、経営権紛争において専門的なサービスを提供。日本人のための法律相談。" },
    { name: "keywords", content: "韓国弁護士, 日本語対応, 国際離婚, 法律相談, 刑事事件, 金融法務, 不動産PF, 経営権紛争, 相続, 離婚, 家事紛争, ソウル" },
    { property: "og:title", content: "法務法人フィサン | 韓国の日本語対応弁護士" },
    { property: "og:description", content: "韓国ソウルの日本語対応法律事務所。国際離婚、刑事事件、金融・企業法務、不動産において専門的なサービスを提供します。" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://jp-hwisang.co.kr/ja" },
    { property: "og:image", content: "https://jp-hwisang.co.kr/images/jp-hwisang-card.jpg" },
    { property: "og:locale", content: "ja_JP" },
    { property: "og:site_name", content: "法務法人フィサン" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: "法務法人フィサン | 韓国の日本語対応弁護士" },
    { name: "twitter:description", content: "韓国ソウルの日本語対応法律事務所。国際離婚、刑事事件、金融・企業法務、不動産において専門的なサービスを提供します。" },
    { name: "twitter:image", content: "https://jp-hwisang.co.kr/images/jp-hwisang-card.jpg" },
    { name: "robots", content: "index, follow" },
    { name: "language", content: "Japanese" },
    { httpEquiv: "content-language", content: "ja" },
  ];
};

export default function JapanIndex() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
            <a href="/ja" className="flex items-center justify-center md:justify-start">
              <img src="/images/no-padding-logo.png" alt="法務法人フィサン" className="h-8 w-auto opacity-90" />
            </a>

            <div className="flex items-center justify-center md:justify-end gap-4 md:gap-6">
              <nav className="flex items-center gap-4 md:gap-6 text-sm">
                <a href="/ja/office" className="text-gray-700 hover:text-black whitespace-nowrap">事務所・所在地</a>
                <a href="/ja/services" className="text-gray-700 hover:text-black whitespace-nowrap">業務分野</a>
                <a href="/ja/blog" className="text-gray-700 hover:text-black whitespace-nowrap">法律ブログ</a>
              </nav>
              <a
                href="https://jp-hwisang.co.kr"
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-1.5 border border-gray-300 hover:border-gray-900 text-gray-700 hover:text-black text-sm transition-colors whitespace-nowrap"
              >
                한국어
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Main Hero Section */}
      <section className="py-20 px-6 md:px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-serif mb-8 text-gray-900 tracking-wide leading-tight">
              法務法人 휘상
            </h1>
            <div className="w-16 h-px bg-gray-400 mx-auto mb-12"></div>
          </div>

          <div className="space-y-12 text-gray-800 leading-loose">
            <p className="text-lg">
              「휘상（フィサン / 輝相）」という名前には、「互いに光り合う」という意味が込められています。私たちは、一人ひとりの依頼人、そして一つひとつの企業の可能性をより明るく輝かせることができるよう、共に歩みます。
            </p>

            <p className="text-lg">
              国際離婚、刑事事件、不動産、金融、企業法務などの分野において、深い知識と誠実なコミュニケーションを基盤に、複雑な問題を明確に解き明かし、依頼者の歩みに確信と可能性をもたらすパートナーでありたいと考えています。
            </p>

            <p className="text-lg font-medium text-center py-8">
              輝相は、結果で証明します。<br />
              今日よりもさらに良い明日へ向けて、<br />
              共に輝く道を築いていきます。
            </p>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="w-24 h-px bg-gray-300 mx-auto my-16"></div>

      {/* Japanese Client Section */}
      <section className="py-20 px-6 md:px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-serif text-center mb-16 text-gray-900">
            私たちは日本人のための<br className="md:hidden" />法律サービスを提供しています。
          </h2>

          <div className="space-y-10 text-gray-800 leading-loose">
            <p className="text-base">
              「휘상（フィサン / 輝相）」は、国際離婚、刑事事件、不動産、金融、企業法務などの分野において、日本語で対応することができます。
            </p>

            <p className="text-base">
              韓国に滞在する日本の方が、ビジネス上の契約問題や交通事故、労働トラブル、さらには離婚や相続などの家庭問題などで法律的なトラブルに直面するケースは少なくありません。韓国に在住の日本人の方が韓国で法的なトラブルに直面した場合、韓国の法律に優れた韓国人弁護士を探す必要があります。
            </p>

            <p className="text-base">
              しかし、法律用語自体が馴染みがなく、すべて韓国語で話を進めなければならない状況は、弁護士とのコミュニケーションにおいて不利になる可能性があります。そのため、まず日本語でスムーズに意思疎通ができる弁護士を見つけることが重要です。
            </p>

            <p className="text-base">
              「휘상（フィサン / 輝相）」は、日本人の方々向けに特化した法律サービスを提供しています。離婚、不動産、刑事事件、金融、企業法務など、さまざまな分野で優れたサービスを提供しており、日本人の皆様にとって大きな助けとなるでしょう。
            </p>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="w-24 h-px bg-gray-300 mx-auto my-16"></div>

      {/* Cultural Understanding Section */}
      <section className="py-20 px-6 md:px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-serif text-center mb-8 text-gray-900 leading-relaxed">
            「文化を理解する弁護士」は、<br />
            通訳ではなく"心を通わせる"パートナー
          </h2>

          <div className="w-16 h-px bg-gray-400 mx-auto mb-16"></div>

          <div className="space-y-10 text-gray-800 leading-loose">
            <p className="text-base">
              「휘상（フィサン / 輝相）」は、国際離婚、刑事事件、不動産、金融、企業法務などの分野において、日本語で対応することができます。
            </p>

            <p className="text-base">
              韓国に滞在する日本の方が、ビジネス上の契約問題や交通事故、労働トラブル、さらには離婚や相続などの家庭問題などで法律的なトラブルに直面するケースは少なくありません。こうした時、単に「日本語が話せる」弁護士ではなく、日韓の文化的背景や価値観の違いを深く理解している弁護士を選ぶことがとても重要です。
            </p>

            <p className="text-base">
              法律トラブルには単なる言語の理解以上に、人の考え方や交渉の仕方、社会的な常識の違いが大きく関係します。日本と韓国では、たとえ似たようなアジア文化圏に属していても、
            </p>

            <ul className="space-y-3 pl-8 border-l-2 border-gray-300">
              <li className="text-base">言葉の使い方のニュアンス</li>
              <li className="text-base">「謝る」や「主張する」ことの受け止め方</li>
              <li className="text-base">法的手続きを進めるときの態度や優先順位</li>
            </ul>

            <p className="text-base">
              などが大きく異なります。
            </p>

            <p className="text-base">
              例えば、日本では「相手に迷惑をかけないように控えめに話す」ことが誠実さの表現とされますが、韓国では「自分の主張を明確に伝える」ことが信頼につながる場合もあります。
            </p>

            <p className="text-base">
              このような文化の違いを理解していないと、弁護士が日本人の立場や感情を正確に伝えきれず、交渉や裁判で不利になることもあります。法律の世界では、「知識と言葉の正確さ」と同じくらい「文化の理解」が重要なのです。
            </p>

            <p className="text-base">
              韓国でトラブルに巻き込まれた日本人が本当に守られるためには、法律・言語・文化の三つを理解する弁護士が必要です。
            </p>

            <p className="text-base font-medium text-center py-8 border-t border-b border-gray-200 my-12">
              「휘상（フィサン / 輝相）」は、異国の地で不安を抱える依頼人にとって、<br />
              最も信頼できる味方になることを心がけています。
            </p>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="w-24 h-px bg-gray-300 mx-auto my-16"></div>

      {/* Services Section */}
      <section id="services" className="py-20 px-4 bg-gray-50">
        <div className="max-w-5xl mx-auto">
          <h3 className="text-3xl font-serif text-center mb-16 text-gray-900">主な業務分野</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            {/* 刑事事件 */}
            <div className="text-center">
              <h4 className="text-xl font-medium mb-4 text-gray-900 border-b border-gray-300 pb-3">刑事事件</h4>
              <p className="text-gray-700 leading-relaxed text-sm">
                性犯罪、経済犯罪、暴力犯罪など、あらゆる刑事事件に対する専門的な弁護
              </p>
            </div>

            {/* 金融・不動産 */}
            <div className="text-center">
              <h4 className="text-xl font-medium mb-4 text-gray-900 border-b border-gray-300 pb-3">金融・不動産</h4>
              <p className="text-gray-700 leading-relaxed text-sm">
                金融訴訟、不動産PF、不動産取引に関する法律サービス
              </p>
            </div>

            {/* 家事事件 */}
            <div className="text-center">
              <h4 className="text-xl font-medium mb-4 text-gray-900 border-b border-gray-300 pb-3">家事事件</h4>
              <p className="text-gray-700 leading-relaxed text-sm">
                離婚、相続、親権など、家族に関する法律問題の解決
              </p>
            </div>
          </div>
          <div className="text-center mt-12">
            <a href="/ja/services">
              <button className="px-12 py-3 border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white transition-colors text-sm tracking-wider">
                業務分野を見る
              </button>
            </a>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="w-24 h-px bg-gray-300 mx-auto my-16"></div>

      {/* Contact Section */}
      <section className="py-20 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h3 className="text-3xl font-serif mb-8 text-gray-900">お問い合わせ</h3>
          <div className="w-16 h-px bg-gray-400 mx-auto mb-12"></div>
          <div className="space-y-6 text-base text-gray-700 leading-relaxed mb-12">
            <p>常にお客様の目線に立って、</p>
            <p>最良の解決を実現できるよう尽力いたします。</p>
            <p>韓国に関する法律問題でお困りの方は、</p>
            <p>お気軽にご相談ください。</p>
          </div>
          <div className="space-y-4">
            <a href="tel:010-4729-3573" className="block text-gray-900 hover:text-gray-600 transition-colors">
              <p className="text-lg font-medium">010-4729-3573</p>
            </a>
            <a href="mailto:mgkim@hwisang.co.kr" className="block text-gray-900 hover:text-gray-600 transition-colors">
              <p className="text-lg font-medium">mgkim@hwisang.co.kr</p>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
            <div>
              <h5 className="text-base font-medium mb-4 text-gray-900">法務法人フィサン</h5>
              <p className="text-sm text-gray-600 leading-relaxed">
                韓国を代表する法律事務所として、<br />
                専門的で信頼できる法律サービスを提供します
              </p>
            </div>
            <div>
              <h5 className="text-base font-medium mb-4 text-gray-900">業務分野</h5>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>刑事事件</li>
                <li>金融・不動産</li>
                <li>経営権紛争</li>
                <li>家事事件</li>
              </ul>
            </div>
            <div>
              <h5 className="text-base font-medium mb-4 text-gray-900">お問い合わせ</h5>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>電話: +82-2-6959-2170</li>
                <li>Email: mgkim@hwisang.co.kr</li>
                <li>住所: ソウル特別市江南区永東大路611, 13階</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-200 mt-8 pt-8 text-center">
            <p className="text-xs text-gray-500">&copy; 2024 法務法人フィサン. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
